import { NavLink } from "@remix-run/react";
import clsx from "clsx";
import { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import * as styles from "./Button.css";
import { WrapperDrawnBorder } from "../wrappers/WrapperDrawnBorder";
import { ButtonChild, DefaultButtonProps } from "./Button";
import { soundButtonDisabled } from "~/lib/hooks/sounds/soundButtonDisabled";
import { soundButtonActive } from "~/lib/hooks/sounds/soundButtonActive";

export type LinkProps = ComponentPropsWithoutRef<typeof NavLink> &
  DefaultButtonProps &
  PropsWithChildren;

export const ButtonLink = ({
  className,
  children,
  theme = "light",
  size = "lg",
  layout = "right",
  width = "fit",
  isDisabled = false,
  icon,
  ...props
}: LinkProps) => {
  const link = (
    <NavLink
      className={clsx(
        className,
        styles.button({
          theme: theme,
          size: size,
          hasIcon: icon ? true : false,
        })
      )}
      onClick={(e) => (
        !isDisabled && soundButtonActive(), props.onClick && props.onClick(e)
      )}
      {...props}
    >
      <ButtonChild icon={icon} layout={layout} isLoading={props.isLoading}>
        {children}
      </ButtonChild>
    </NavLink>
  );
  return (
    <div
      className={styles.wrapper({ width: width })}
      onClick={() => (isDisabled ? soundButtonDisabled() : soundButtonActive())}
    >
      {theme === "text" ? (
        link
      ) : (
        <WrapperDrawnBorder
          className={styles.wrapper({ isDisabled: isDisabled, width: width })}
        >
          {link}
        </WrapperDrawnBorder>
      )}
    </div>
  );
};
